@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.large-icon {
  height: 24px;
  width: 24px;
  padding: 3px; // Figma padding
}

.medium-icon {
  height: 16px;
  width: 16px;
}

.small-icon {
  height: 12px;
  width: 12px;
}

.primary {
  color: @info-icon--icon-color;
}

.unstyled {
  color: var(--default--icon--fill-color--12);
}

.white {
  color: var(--light--icon--fill-color--1);
}
